/* ###############################  
        Part 1 of 2 Swiper v8
  ##################################  */
var swiper = new Swiper(".mySwiper", {
    slidesPerView: 3,
    spaceBetween: 30,
    loop: true,
    breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    /* remove/comment to stop autoplay*/
    autoplay: {
        delay: 7000,
        disableOnInteraction: false
    },
});

/* ###############################  
       Part 2 of 2 PhotoSwipe v5
  ##################################  */
/* https://photoswipe.com/getting-started/ */

import PhotoSwipeLightbox from 'https://unpkg.com/photoswipe@5.4.2/dist/photoswipe-lightbox.esm.js';
import PhotoSwipe from 'https://unpkg.com/photoswipe@5.4.2/dist/photoswipe.esm.js';

const photo_swipe_options = {
    gallery: '#my-gallery',
    pswpModule: PhotoSwipe,
    // set background opacity
    bgOpacity: 0.2,
    children: 'a',
    loop: true,
    showHideAnimationType: 'fade',
    /* options: fade, zoom, none */

    /* Click on image moves to the next slide */
    imageClickAction: 'next',
    tapAction: 'next',

    /* ## Hiding a specific UI element ## */
    zoom: false,
    close: true,
    counter: true,
    arrowKeys: true,
    /* ## Options ## */
    wheelToZoom: false,
    /* deafult: undefined */
};

const lightbox = new PhotoSwipeLightbox(photo_swipe_options);

lightbox.init();

lightbox.on('change', () => {
    const {
        pswp
    } = lightbox;
    swiper.slideTo(pswp.currIndex, 0, false);
    console.log('Slide index', pswp.currIndex);
    //console.log('Slide object', pswp.currSlide);
    //console.log('Slide object data', pswp.currSlide.data);
});

/* ### PhotoSwipe events ### */

lightbox.on('afterInit', () => {
    const {
        pswp
    } = lightbox;
    if (swiper.params.autoplay.enabled) {
        swiper.autoplay.stop();
    };
});

lightbox.on('closingAnimationStart', () => {
    //console.log('closingAnimationStart');
    const {
        pswp
    } = lightbox;
    swiper.slideTo(pswp.currIndex, 0, false);
    /* if autoplay enabled == true -> autoplay.start() when close lightbox */
    if (swiper.params.autoplay.enabled) {
        swiper.autoplay.start();
    }
});